import { render, staticRenderFns } from "./EventPurchasedTickets.vue?vue&type=template&id=880c41ea&scoped=true"
import script from "./EventPurchasedTickets.vue?vue&type=script&setup=true&lang=ts"
export * from "./EventPurchasedTickets.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./EventPurchasedTickets.vue?vue&type=style&index=0&id=880c41ea&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "880c41ea",
  null
  
)

export default component.exports